import { NumberValue, VALUE_TYPE } from "Components/NumberValue";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { InsuranceProduct } from "Store/interfaces/products/checkout";
import { oneTimePrice, pricePerMonth } from "Utils/priceUtils";
import React from "react";
import { PriceWrapper } from "./styled";

interface Props {
  readonly product: InsuranceProduct;
}

export const CardHeaderPrice = ({
  product,
}: Props): React.ReactElement | null => {
  const price = pricePerMonth(product);

  if (price) {
    if (product.name === INSURANCE_NAME_VALUE.PREGNANT_AND_NEWBORN) {
      return (
        <PriceWrapper>
          <p>
            <NumberValue
              value={oneTimePrice(product)}
              type={VALUE_TYPE.NOK}
              boldValue
              largeValue
            />
          </p>
        </PriceWrapper>
      );
    }

    return (
      <PriceWrapper>
        <p>
          <NumberValue
            value={price}
            type={VALUE_TYPE.NOK_MONTH}
            boldValue
            largeValue
          />
        </p>
      </PriceWrapper>
    );
  }

  return null;
};
